export default __webpack_public_path__ + "static/src/companys/fubon/assets/images/icons/marketdetail_indicator_icon_yellow.png";